
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://yhwmxrfijkhohisckbzj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inlod214cmZpamtob2hpc2NrYnpqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDEyNzE5MDcsImV4cCI6MjA1Njg0NzkwN30.gsnDHHsaUZE7WCfIT33C5VDSXpgGqwXl0NQk_waNbeI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
